<template>
  <header id="app-header">
    <div class="container">
      <nav class="navbar navbar-expand-md navbar-light">
        <router-link tag="a" id="home-nav" to="/" exact>
          <h1 id="app-header-logo"><img src="/static/img/logo-512x109.png" alt="TEDxOsakaU"></h1>
        </router-link>
        <button class="navbar-toggler" type="button"
                data-toggle="collapse" data-target="#nav-bar-menu"
                aria-controls="nav-bar-menu"
                aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="nav-bar-menu">
          <ul class="navbar-nav">
            <li class="nav-item" v-bind:class="{ active: current === 'Events' }">
              <router-link tag="a" class="nav-link" id="event-nav" to="/events">
                Events
              </router-link>
            </li>
            <li class="nav-item" v-bind:class="{ active: current === 'Speakers' }">
              <router-link tag="a" class="nav-link" id="speakers-nav" to="/speakers">
                Speakers
              </router-link>
            </li>
            <li class="nav-item" v-bind:class="{ active: current === 'Partners' }">
              <router-link tag="a" class="nav-link" id="partners-nav" to="/partners">
                Partners
              </router-link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      current: this.$route.name,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/global";

#app-header:before {
  position: fixed;
  width: 100%;
  margin-bottom: 0;
  z-index: 9999999;
}

#app-header {
  background: rgba(#fff, .95);
  padding: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  border-bottom: 1px solid rgba($brand-black, .2);
}

#app-header {
  .navbar {
    padding: 0;
  }
}

#app-header-logo {
  position: relative;
  z-index: 2;
  margin-top: 8px;
  margin-bottom: 8px;
  float: left;

  img {
    vertical-align: middle;
    height: 36px;
    margin: 4px 0;
  }
}

#nav-bar-menu {
  justify-content: flex-end;
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue